export const amountToCents = (amount) => {
  const amountOrZero = amount || 0;

  if (+amountOrZero % 1 !== 0 || typeof amountOrZero === 'string')
    return Math.round(amountOrZero * 100);

  return amountOrZero;
};
